(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFilesDetailController', TabFilesDetailController);

    TabFilesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabFiles', 'DataUtils'];

    function TabFilesDetailController($scope, $rootScope, $stateParams, entity, TabFiles, DataUtils) {
        var vm = this;
        vm.tabFiles = entity;
        vm.openFile = false;
        vm.fileContent = '';
        vm.tabFiles.$promise.then(function(test){
            vm.fileContent = window.atob(vm.tabFiles.fileContent);
        });



        var unsubscribe = $rootScope.$on('jotApp:tabFilesUpdate', function (event, result) {
            vm.tabFiles = result;
        });
        $scope.$on('$destroy', unsubscribe);
        vm.byteSize = DataUtils.byteSize;
        //vm.openFile = DataUtils.openFile;

    }
})();
